import { GetImsIdentityResponse } from '../types/ims';
import { store } from '../redux/store';
import axios from 'axios';

export interface IIdentityManagementService {
  getIdentity(identityId: string): Promise<GetImsIdentityResponse>;
}

export interface ImsRequestHeaders {
  Authorization: string;
}

class IdentityManagementService implements IIdentityManagementService {
  async getIdentity(identityId: string): Promise<GetImsIdentityResponse> {
    const identityUrl = this.getIdentityUrl(identityId);
    const accessToken = await this.getAccessToken();

    const response = await axios.get<GetImsIdentityResponse>(identityUrl, {
      headers: {
        ...this.getImsRequestHeaders(accessToken),
      },
    });
    return response.data;
  }

  private getImsApiConfig = () => store.getState().apiConfig.ims;

  private getIdentityUrl = (identityId: string): string => {
    const config = this.getImsApiConfig();
    return `${config.apiRoot}/${config.fusionAuthVersion}/api/identities/${identityId}`;
  };

  private getAccessToken = async () => await window.auth.getAccessToken();

  private getImsRequestHeaders = (accessToken: string): ImsRequestHeaders => ({
    Authorization: `Bearer ${accessToken}`,
  });
}

export const identityManagementService: IIdentityManagementService =
  new IdentityManagementService();
